import request from '../ajax_request.js'
import {base_url, debug_obj} from "../base_api"


console.log("DEBUG_OBJ:",debug_obj);

export function lookup_products_by_gid(gid){
    let def_base_url = base_url + "/pos";

	let url = `${def_base_url}/product?oper=lookup&gid=${gid}`;
	return request({
        url,
        method: 'get',
        // params:{shop_id:'558cddd574184c39d2abf993',api:'mobile_device'}
        params:debug_obj
    })
}

export function lookup_home_stock({gid,name}){
    let def_base_url = base_url + "/pos";

	let url = `${def_base_url}/product?oper=store_count&gid=${gid?gid:''}&name=${name?name:''}`;
	return request({
        url,
        method: 'get',
        // params:{shop_id:'558cddd574184c39d2abf993',api:'mobile_device'}
        params:debug_obj
    })
}



// WEBPACK FOOTER //
// ./src/api/module/products.js